import React from 'react';
import { View, Text } from 'react-native';
import { globalStyles } from '../../styles/globalStyles';

export function VenueHeader({ title }) {
  return (
    <View style={globalStyles.venueHeaderContainer}>
      <Text style={globalStyles.venueHeaderTitle}>{title}</Text>
    </View>
  );
} 